import { useMutation } from '@tanstack/react-query';
import {
  BidvBankTransferService,
  BidvDebitTransactionSyncEntity,
  SyncTransactionDto,
} from 'services/openapi';

export const useBidvSyncTransactionMutation = () =>
  useMutation<BidvDebitTransactionSyncEntity, Error, SyncTransactionDto>({
    mutationFn: (requestBody) =>
      BidvBankTransferService.bidvBankTransferControllerSyncTransaction(
        requestBody,
      ),
    retry: 0,
  });
